import React from 'react';
import './HeroSection.css';
import engDetail1 from '../Assets/hero/1.webp';
import engDetail2 from '../Assets/hero/2.webp';

const HeroSection = () => {
  return (
    <div className="hero-main-container">
      {/* Sidebar Socials/Text (Optional, matches image) */}
      <div className="hero-sidebar-info">EST. 2001 — ENGINEERING SOLUTIONS</div>

      {/* Main Left Text Area */}
      <section className="panel-content">
        <h1 className="hero-big-title">
          MTPRO <br />
          ENGINEERING
        </h1>
        <p className="hero-sub-mission">
          Beyond project management. Adopting state-of-the-art technology for 
          medium to enterprise-scale project excellence.
        </p>
        
        {/* Animated Badge */}
        <div className="discover-badge">
           <span style={{color: '#fff', fontWeight: 'bold', fontSize: '24px'}}>→</span>
        </div>
      </section>

      {/* Vertical Image Panels */}
      <div 
        className="panel-image" 
        style={{ backgroundImage: `url(${engDetail1})` }} 
      />
      <div 
        className="panel-image" 
        style={{ backgroundImage: `url(${engDetail2})` }} 
      />
    </div>
  );
};

export default HeroSection;